import BuilderFilterFields from './BuilderFilterFields';
import BuilderFilterFieldsTrigger from './BuilderFilterFieldsTrigger';
import { withHighlightingContext } from '../../../HighlightingContext';

const BuilderFilterFieldsHighlighted =
  withHighlightingContext(BuilderFilterFields);

export {
  BuilderFilterFields,
  BuilderFilterFieldsTrigger,
  BuilderFilterFieldsHighlighted,
};
